import React from 'react';
import { Box, Typography } from '@mui/material';

interface FieldRowProps {
  label: string;
  value: string;
}

const FieldRow: React.FC<FieldRowProps> = ({ label, value }) => (
  <Box
    sx={{
      display: 'flex',
      py: 0.75,
      borderBottom: '1px solid',
      borderColor: 'divider',
      gap: 2,
    }}
  >
    <Typography
      variant="body2"
      sx={{
        fontWeight: 600,
        minWidth: 280,
        flexShrink: 0,
        color: 'text.primary',
      }}
    >
      {label}:
    </Typography>
    <Typography
      variant="body2"
      sx={{ color: 'text.secondary', wordBreak: 'break-word' }}
    >
      {value}
    </Typography>
  </Box>
);

export default React.memo(FieldRow);
